/**
 * src/shell/agents/services/AgentFeedbackLoop.ts
 *
 * Captures user edits and ratings on generated artifacts
 * as learning signals to refine future generations.
 */

export interface FeedbackRecord {
  id: string;
  agentId: string;
  userId: string;
  prompt: string;
  originalOutput: string;
  editedOutput: string;
  rating?: number; // 1 - 5 stars
  timestamp: number;
}

export class AgentFeedbackLoop {
  private static instance: AgentFeedbackLoop;
  private records: FeedbackRecord[] = [];

  private constructor() {}

  public static getInstance(): AgentFeedbackLoop {
    if (!AgentFeedbackLoop.instance) {
      AgentFeedbackLoop.instance = new AgentFeedbackLoop();
    }
    return AgentFeedbackLoop.instance;
  }

  public recordFeedback(
    agentId: string,
    userId: string,
    prompt: string,
    originalOutput: string,
    editedOutput: string,
    rating?: number
  ): FeedbackRecord {
    const record: FeedbackRecord = {
      id: `fb_${Date.now()}_${Math.random().toString(36).slice(2, 6)}`,
      agentId,
      userId,
      prompt,
      originalOutput,
      editedOutput,
      rating,
      timestamp: Date.now(),
    };

    this.records.push(record);
    return record;
  }

  public getFeedbackStats(agentId?: string): { totalEdits: number; avgRating: number } {
    const subset = agentId ? this.records.filter((r) => r.agentId === agentId) : this.records;
    if (subset.length === 0) return { totalEdits: 0, avgRating: 5.0 };

    const rated = subset.filter((r) => r.rating !== undefined);
    const avgRating = rated.length > 0
      ? Number((rated.reduce((acc, curr) => acc + (curr.rating || 0), 0) / rated.length).toFixed(1))
      : 5.0;

    return { totalEdits: subset.length, avgRating };
  }
}

export const agentFeedbackLoop = AgentFeedbackLoop.getInstance();
